export const DOCUMENT_STATUS = {
  PENDING_INDEXING: 1000,
  PENDING_SCANNING: 1001,
  SCANNING: 1002,
  PENDING_APPROVAL: 1003,
  INDEXING: 1004,
  INDEXED: 1005,
  FAILED_INDEXING: 1006,
  FAILED_SCANNING: 1007,
  // Assistant documents only: created in PENDING_VALIDATION (no metadata yet),
  // validated by the indexing job (VALIDATING), parked in FAILED_VALIDATION
  // with a statusReason when the file is invalid.
  PENDING_VALIDATION: 1008,
  VALIDATING: 1009,
  FAILED_VALIDATION: 1010,
};

export const DOCUMENT_STATUS_COLORS = {
  [DOCUMENT_STATUS.PENDING_INDEXING]: "text-warning",
  [DOCUMENT_STATUS.PENDING_SCANNING]: "text-warning",
  [DOCUMENT_STATUS.SCANNING]: "text-brand",
  [DOCUMENT_STATUS.PENDING_APPROVAL]: "text-brown",
  [DOCUMENT_STATUS.INDEXING]: "text-brand",
  [DOCUMENT_STATUS.INDEXED]: "text-success",
  [DOCUMENT_STATUS.FAILED_INDEXING]: "text-danger",
  [DOCUMENT_STATUS.FAILED_SCANNING]: "text-danger",
  [DOCUMENT_STATUS.PENDING_VALIDATION]: "text-warning",
  [DOCUMENT_STATUS.VALIDATING]: "text-brand",
  [DOCUMENT_STATUS.FAILED_VALIDATION]: "text-danger",
};

export const DOCUMENT_SORTING_KEY = {
  NAME: "title",
  AI_GENERATED_TITLE: "aiGeneratedTitle",
  MATCHES_FOUND: "matchesFound",
  STATUS: "status",
};

export const DOCUMENT_LANGUAGES = {
  ENGLISH: "English",
  GERMAN: "German",
  POLISH: "Polish",
};

// Moved to @shared/constants/documents so the portal's document preview uses
// the same values. Re-exported to keep oem's paths working.
export {
  DEFAULT_DOCUMENT_LANGUAGE_OPTION,
  DOC_FILE_TYPES,
  IMAGE_FILE_TYPES,
  TRANSLATION_STATUS,
} from "@shared/constants/documents";
